// extracted by mini-css-extract-plugin
export default {"pageBottom":"index_pageBottom_m9Xmh"};